import { render, staticRenderFns } from "./SettingsDetails.vue?vue&type=template&id=ba08f1de&"
import script from "./SettingsDetails.vue?vue&type=script&lang=js&"
export * from "./SettingsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports